(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peak-leaf-new-listings"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-pln-filter]');
    if (!tab) return;
    const root = tab.closest('[data-pln]');
    if (!root) return;
    const filter = tab.dataset.plnFilter;
    root.querySelectorAll('[data-pln-filter]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === tab));
    });
    root.querySelectorAll('[data-pln-type]').forEach((card) => {
      const show = filter === 'all' || card.dataset.plnType === filter;
      card.hidden = !show;
      if (show) {
        card.classList.remove('pln__card--in');
        void card.offsetWidth;
        card.classList.add('pln__card--in');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
